<template>
    <div class="m-content" style="padding: 0;">
        <div class="m-portlet m-portlet--mobile" v-if="previewProduct">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">{{ previewProduct.name }} </h3>
                    </div>
                </div>
                <div class="m-portlet__head-tools" v-if="!productId">
                    <ul class="m-portlet__nav">
                        <router-link
                                v-if="canEditProduct"
                                tag="button"
                                :to="{ name: 'ProductFormExt', query: { 'productId': previewProduct.productId }}"
                                class="btn btn-primary btn-sm" style="margin-right: 5px;">{{ labels.edit_product }}</router-link>
                        <button
                                v-if="canDeleteProduct"
                                @click="triggerDuplicateAction(previewProduct.productId)"
                                class="btn btn-success btn-sm" style="margin-right: 5px;">
                            <span><i class="la la-copy"></i></span> {{ labels.duplicate_product }}</button>
                        <button
                                v-if="canDeleteProduct"
                                @click="triggerDeleteAction(previewProduct.productId, previewProduct.name)"
                                class="btn btn-info btn-sm" style="margin-right: 5px;">
                            <span><i class="la la-trash"></i></span> {{ labels.delete_product }}</button>
                        <button
                                tag="button"
                                @click="$router.go(-1)"
                                class="btn btn-secondary btn-sm" style="margin-right: 5px;">{{ labels.return }}</button>
                    </ul>
                </div>
            </div>

            <div class="row outer" v-if="!productId">
                <!-- PHOTO SLIDE PORTLET -->
                <div class="col-lg-4">
                    <images :previewProduct="previewProduct"></images>
                    <!-- COMPLIMENTARY INFO PORTLET ?? -->
                    <complimentary-info :previewProduct="previewProduct"></complimentary-info>
                </div>
                <!-- BASIC INFO PORTLET: country, product name, brand, status, type skin, area, type pack , link to product on website -->
                <div class="col-lg-8">
                    <basic-info :previewProduct="previewProduct"></basic-info>
                    <!-- SPECIFIC INFO PORTLET: galerique texturotheque, tinted, spf, uva, perfumes, INCI list -->
                    <further-info :previewProduct="previewProduct"></further-info>

                </div>
                <div class="col-lg-12">
                    <!-- CLAIMS PORTLET: Speicifc mentions, country made, tab view for efficiency & security claims  -->
                    <claims :previewProduct="previewProduct" :keywordSearch="keywordSearch"></claims>
                    <!-- ACTIVE INGREDIENTS PORTLET -->
                    <product-data crudName="ingredients" :list="ingredients" v-if="!marketingRole"></product-data>
                    <!-- PATENTS PORTLET -->
                    <product-data crudName="patents" :list="patents"></product-data>

                    <product-data crudName="roles" :list="roles" v-if="!marketingRole"></product-data>

                    <product-data crudName="segmentations" :list="segmentations"></product-data>

                    <preview-stock stocks="stocks" :previewProduct="previewProduct" v-if="stockAccessRead"></preview-stock>
                </div>

            </div>

            <div class="row outer" v-else>
                <!-- PHOTO SLIDE PORTLET -->
                <div class="col-lg-12">
                    <images :previewProduct="previewProduct"></images>
                    <!-- BASIC PRODUCT INFO -->
                    <basic-info :previewProduct="previewProduct"></basic-info>
                    <!-- SPECIFIC INFO PORTLET: galerique texturotheque, tinted, spf, uva, perfumes, INCI list -->
                    <further-info :previewProduct="previewProduct" compareMode="1"></further-info>
                    <!-- COMPLIMENTARY INFO PORTLET ?? -->
                    <complimentary-info :previewProduct="previewProduct"></complimentary-info>
                </div>
                <!-- BASIC INFO PORTLET: country, product name, brand, status, type skin, area, type pack , link to product on website -->
                <div class="col-lg-12">
                    <!-- CLAIMS PORTLET: Speicifc mentions, country made, tab view for efficiency & security claims  -->
                    <claims :previewProduct="previewProduct" :keywordSearch="keywordSearch" compareMode="1"></claims>
                    <!-- ACTIVE INGREDIENTS PORTLET -->
                    <product-data crudName="ingredients" :list="ingredients" compareMode="1" v-if="!marketingRole"></product-data>
                    <!-- PATENTS PORTLET -->
                    <product-data crudName="patents" :list="patents" compareMode="1"></product-data>

                    <product-data crudName="roles" :list="roles" compareMode="1" v-if="!marketingRole"></product-data>

                    <product-data crudName="segmentations" :list="segmentations" compareMode="1"></product-data>

                    <preview-stock stocks="stocks" :previewProduct="previewProduct" v-if="stockAccessRead"></preview-stock>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
// Components
import { mapState, mapGetters, mapActions } from 'vuex';
import Images from './Images';
import BasicInfo from './BasicInfo';
import FurtherInfo from './FurtherInfo';
import Claims from './Claims';
import ProductData from './ProductData';
import ComplimentaryInfo from './ComplimentaryInfo';
import PreviewStock from './PreviewStock';
// Mixins
import Uuid from '../../../assets/js/mixins';
import duplicateAction from '../../../assets/js/duplicateMixin';
import deleteProductAction from '../../../assets/js/deleteProductMixin';
// Resources
import { HTTP } from '../../../assets/js/axiosConfig';

import { firestoreDB } from '../../../assets/js/firebase';

export default {
  name: 'PreviewProduct',
  props: ['productId'],
  mixins: [Uuid, duplicateAction, deleteProductAction],
  components: {
    Images,
    BasicInfo,
    FurtherInfo,
    Claims,
    ProductData,
    ComplimentaryInfo,
    PreviewStock,
  },
  data() {
    return {
      ingredients: [],
      roles: [],
      patents: [],
      segmentations: [],
      themes: [],
      stocks: [],
      previewProduct: null,
      keywordSearch: '',
    };
  },
  watch: {
    previewProduct() {
      if (this.previewProduct) {
        if (!this.marketingRole) {
          this.getProductIngredients();
        }
        this.getProductPatents();
        this.getProductSegmentations();
      }
    },
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
      productIndex: (state) => state.products.productIndex,
      previewURL: (state) => state.products.previewURL,
      lastSearch: (state) => state.products.lastSearch,
    }),
    ...mapGetters([
      'products/getLinkedData',
      'canDeleteProduct',
      'canDuplicateProduct',
      'canEditProduct',
      'stockAccess',
      'stockAccessRead',
      'marketingRole',
      'getResourceValue',
      'getResourceValueFirestore',
    ]),
  },
  methods: {
    ...mapActions('products', [
      'setPreviewProduct',
    ]),
    getProductPatents() {
      firestoreDB
        .collection(`${process.env.ENV_SHORTNAME}_products_patents`)
        .doc(this.previewProduct.productId)
        .collection('patents')
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.docs) {
            const my = this;
            this.patents = querySnapshot.docs.map((doc) => {
              const data = doc.data();
              data.number = this.getResourceValue(data.patent_id, 'patent_id', 'patents', 'number');
              data.name = this.getResourceValue(data.patent_id, 'patent_id', 'patents', 'name');
              data.roles = data.roles.map((role) => {
                my.roles.push({
                  dosage: null,
                  ingredient_id: null,
                  related_inci: null,
                  role_id: role.role_id,
                  mode_action_id: role.mode_action_id,
                  is_patent: true,
                });
                return this.getResourceValue(role.role_id, 'role_id', 'roles', 'name');
              });
              data.ingredients = data.ingredients.map((ingredient) => this.getResourceValue(ingredient.ingredient_id, 'ingredient_id', 'ingredients', 'name'));

              return data;
            });
          }
        })
        .catch((error) => {
          console.error('Error : ', error);
        });
    },
    getProductIngredients() {
      const my = this;
      HTTP.get(`api/products/${this.previewProduct.productId}/ingredients`)
        .then((response) => {
          this.ingredients = response.data;
          this.ingredients.forEach((ingredient, index) => {
            ingredient.name = this.previewProduct._highlightResult.hasOwnProperty('ingredients') && this.previewProduct._highlightResult.ingredients[index] ? this.previewProduct._highlightResult.ingredients[index].value : this.previewProduct.ingredients[index];
            ingredient.related_inci = my.getResourceValueFirestore(ingredient.related_inci, 'related_inci', 'name');
            this.getIngredientById(ingredient);
          });
        })
        .catch((err) => {
          console.log(err);
          this.ingredients = [];
        });
    },
    getIngredientById(ingredient) {
      const my = this;
      HTTP.get(`api/products/${this.previewProduct.productId}/ingredients/${ingredient.ingredient_id}`)
        .then((response) => {
          if (response.data.roles.length) {
            response.data.roles.map((role) => {
              role.ingredient_id = ingredient.ingredient_id;
              role.dosage = ingredient.dosage;
              role.related_inci = ingredient.related_inci;
              role.is_patent = false;
              my.roles.push(role);
            });
          }
        })
        .catch((err) => console.log(err));
    },
    getProductSegmentations() {
      HTTP.get(`api/segmentations/product/${this.previewProduct.productId}`)
        .then((response) => {
          this.segmentations = response.data;
          this.getSegmentationVerbatims();
        })
        .catch((err) => console.log(err));
    },
    getSegmentationVerbatims() {
      this.segmentations.forEach((segmentation) => {
        segmentation.verbatim_consos = [];
        const verbatims = this['products/getLinkedData'](segmentation.segmentation_id, 'verbatim_consos', 'segmentations');
        verbatims.map((verbatim) => segmentation.verbatim_consos.push(verbatim.name));
      });
    },
    async getLastQuery(id, deleteKeyword) {
      if (id && this.previewURL.length) {
        // Get the last result object
        const lastResult = this.previewURL[0];
        if (lastResult) {
          const queryArray = lastResult.params.split('&');
          const searchParameters = await this.createParams(queryArray, id, deleteKeyword);
          searchParameters;
          this.callToAlgolia(searchParameters, id);
        }
      } else if (id) {
        this.callToAlgolia({
          distinct: true,
          attributesToRetrieve: '["*"]',
          attributesToHighlight: '*',
          hitsPerPage: 1,
          facets: '["productId"]',
          facetFilters: `[["productId:${id}"]]`,
          page: 0,
        }, id);
      }
    },
    async createParams(params, id, deleteKeyword) {
      const my = this;
      try {
        let searchParameters = {
          attributesToRetrieve: '["*"]',
          attributesToHighlight: '*',
          hitsPerPage: 1,
          facets: '["productId"]',
          facetFilters: `[["productId:${id}"]]`,
          page: 0,
        };

        let index = 0;
        for (index; index < params.length; index++) {
          const splitParam = params[index].split('=');
          const key = decodeURIComponent(splitParam[0]);
          const value = decodeURIComponent(splitParam[1]);

          if (key === 'query') {
            my.keywordSearch = value;
            deleteKeyword ? searchParameters[key] = '' : searchParameters[key] = value;
          }

          if (key === 'restrictSearchableAttributes' && value.length > 2) {
            if (value.indexOf('claimsEfficiency') !== -1) {
              searchParameters = {
                attributesToHighlight: '*',
                facets: '["productId"]',
                facetFilters: `[["productId:${id}"]]`,
                query: '',
              };
              break;
            } else {
              my.keywordSearch = '';
            }
          }

          key !== 'page' && key !== 'query' && key !== 'facetFilters' && key !== 'attributesToRetrieve' && key !== 'facets' && key !== 'hitsPerPage' && key !== 'attributesToHighlight' ? searchParameters[key] = value : null;
        }
        return await searchParameters;
      } catch (err) {
        console.log(err);
      }
    },
    callToAlgolia(searchParameters, id) {
      const my = this;
      this.productIndex.clearCache();
      this.productIndex.search(searchParameters,
        (err, content) => {
          if (err) throw err;
          if (content.hits[0].isClaim) {
            my.getLastQuery(id, true);
          } else {
            my.previewProduct = content.hits[0];
          }
        });
    },
  },
  mounted() {
    const id = this.$route.query.productId || this.productId;
    id ? this.getLastQuery(id) : this.previewProduct = null;
  },
};
</script>

<style>
    .row.outer {
        padding: 20px;
    }
    .custom_scroll {
        overflow: hidden;
        min-height: 400px;
        max-height: 400px;
        overflow-y: scroll;
    }
    .custom_scroll_long {
        overflow: hidden;
        min-height: 600px;
        max-height: 600px;
        overflow-y: scroll;
    }
    .claim-sect {
        padding: 5px 0;
    }
    .larger-text {
        font-size: 1.2rem;
    }
    .custom_table_scroll {
        overflow:hidden;
        overflow-y: scroll;
    }
    .m-portlet__head.preview {
        background-color: #002738;
    }
    .m-portlet__head.preview .m-portlet__head-text {
        color: #f5eb62;
        font-size: 1.4rem;
    }
    .m-portlet .m-portlet__head.preview .m-portlet__head-tools .m-portlet__nav .m-portlet__nav-item .m-portlet__nav-link.m-portlet__nav-link--icon i {
        color: #f5eb62;
    }
    .text_bolder {
        font-weight: 500;
    }
    .m-portlet__body em {
        font-weight: bold;
        color: #1b7e9a;
    }
</style>



// WEBPACK FOOTER //
// src/components/Products/Preview/PreviewProduct.vue